import axios from 'axios'
axios.defaults.withCredentials = true

let baseUrl = process.env.NODE_ENV === 'development' ? '/daohang' : '/'


const service = axios.create({
  baseURL: baseUrl,
  timeout: 1000 * 5
})
service.interceptors.request.use(config => {
    return config
})

service.interceptors.response.use(res => {
    let data = res.data
    let code = data.code
    if (typeof data === 'string') {
        data = JSON.parse(data)
    }
    if (code === 0 || isNaN(code)) {
        return data
    } else {
        if (code === 1000000500) {
            if (data.data && data.data.redirectUrl) {
                let url = window.location.href
                let oaToken = sessionStorage.getItem('oaToken')
                // eslint-disable-next-line max-depth
                if (!localStorage.getItem('token') && !oaToken) {
                    window.location.href = data.data.redirectUrl + encodeURIComponent(url)
                }
            } 
        }
        return Promise.reject(data)
    }
}, error => {
    // let response = error.response
    // let data = response.data
    // let status = error.response.status

    return Promise.reject(error)
})


/**
 * 发送 post 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
export async function postWithJson(url, data = {}) {
    return service.post(url, data)
}

/**
 * 发送 get 请求
 *
 * @param {string} url 请求 url
 * @param {Object} data 发送的数据
 * @return {Promise}
 */
 export function get(url, data = {}) {
    return service.get(url, {
        params: data
    })
}
